import * as en from './en';

// This is only a hack so we can test that translations work correctly.

const copy = structuredClone(en.dict);

export const dict = copy;
